import { Loader } from '@mobalytics/shared';
import * as React from 'react';
import { AppLayout } from '../../ui/layout/app-layout/app-layout.component';
import { FullScreenCenter } from '../../ui/layout/full-screen-center/full-screen-center.component';
import { DynamicModuleContextDefaultValue, DynamicModuleContextI } from './dynamic-modules.types';
import { useFetchDynamicModules } from './use-fetch-dynamic-modules.hook';

const DynamicModulesContext = React.createContext<DynamicModuleContextI>(DynamicModuleContextDefaultValue);

type DynamicModulesProviderProps = {
  children: React.ReactNode;
};

export const DynamicModulesProvider = (props: DynamicModulesProviderProps) => {
  const { children } = props;
  const { isLoaded, dynamicModulesData } = useFetchDynamicModules();
  const value = dynamicModulesData ?? DynamicModuleContextDefaultValue;
  return (
    <DynamicModulesContext.Provider value={value}>
      {isLoaded ? (
        children
      ) : (
        <AppLayout>
          <FullScreenCenter>
            <Loader />
          </FullScreenCenter>
        </AppLayout>
      )}
    </DynamicModulesContext.Provider>
  );
};

export const useDynamicModules = (): DynamicModuleContextI => React.useContext(DynamicModulesContext);
